import styled from "styled-components";
import { Grid } from "@material-ui/core";

const TableGrid = styled(Grid)`
  border-radius: 5px;
  border: solid 1px #ebeef1;
`;

export default TableGrid;
